import { UseCatalogListMassActionsReturn } from '../../hooks/types/useCatalogListMassActions.types';
import CatalogBatchActivateModal from './CatalogBatchActivateModal';
import CatalogBatchAddClassificationsModal from './CatalogBatchAddClassificationsModal';
import CatalogBatchAddCustomersModal from './CatalogBatchAddCustomersModal';
import CatalogBatchAddSalesRepsModal from './CatalogBatchAddSalesRepsModal';
import CatalogBatchInactivateModal from './CatalogBatchInactivateModal';
import CatalogBatchRemoveModal from './CatalogBatchRemoveModal';

interface CatalogBulkModalsProps {
  massActions: UseCatalogListMassActionsReturn;
}

const CatalogBulkModals = ({ massActions }: CatalogBulkModalsProps) => (
  <>
    <CatalogBatchActivateModal
      open={massActions.isActivateModalOpen}
      onClose={massActions.closeActivateModal}
      onConfirm={massActions.handleBatchActivate}
    />
    <CatalogBatchInactivateModal
      open={massActions.isInactivateModalOpen}
      onClose={massActions.closeInactivateModal}
      onConfirm={massActions.handleBatchInactivate}
    />
    <CatalogBatchRemoveModal
      open={massActions.isRemoveModalOpen}
      onClose={massActions.closeRemoveModal}
      onConfirm={massActions.handleBatchRemove}
    />
    <CatalogBatchAddCustomersModal
      open={massActions.isAddCustomersModalOpen}
      onClose={massActions.closeAddCustomersModal}
      onConfirm={massActions.handleBatchAddCustomers}
    />
    <CatalogBatchAddSalesRepsModal
      open={massActions.isAddRepsModalOpen}
      onClose={massActions.closeAddRepsModal}
      onConfirm={massActions.handleBatchAddReps}
    />
    <CatalogBatchAddClassificationsModal
      open={massActions.isAddClassificationsModalOpen}
      onClose={massActions.closeAddClassificationsModal}
      onConfirm={massActions.handleBatchAddClassifications}
    />
  </>
);

export default CatalogBulkModals;
